<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="商品SKU"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:'首页'}
      ,{path:'/goods',breadcrumbName:'商品列表'}
      ,{path:`/${goodsId}`,breadcrumbName:'商品信息'}
      ,{path:`/goods/${goodsId}/sku`,breadcrumbName:'商品SKU'}
      ] } }"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['sku']" mode="horizontal">
        <a-menu-item
          key="info"
          @click="()=>{this.$router.push(`/goods/${goodsId}`)}">
          <a-icon type="mail"/>
          商品信息
        </a-menu-item>
        <a-menu-item
          key="sku"
          :disabled="!goodsId">
          <a-icon type="appstore"/>
          SKU
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button @click="()=>{this.$router.push(`/goods/${goodsId}`)}">返回</a-button>
      </a-space>
    </div>
    <a-spin :spinning="form.loading">
      <div style="margin: 16px">
        <a-row :gutter="20">
<!--          <a-col :span="8">-->
<!--            <a-card-->
<!--              :title="item.name"-->
<!--              style="margin-top: 20px"-->
<!--              :key="`${item.value}${index}`"-->
<!--              v-for="(item,index) in attribute.data">-->
<!--              <a-button-->
<!--                v-if="item.code !== goods.basicSpec"-->
<!--                slot="extra"-->
<!--                type="link"-->
<!--                @click="setBasicSpec(item.code)">-->
<!--                <a-icon type="file-image"/>-->
<!--              </a-button>-->
<!--              <a-button slot="extra" type="link" @click="addSpec(item.code)">添加</a-button>-->
<!--              <a-list :data-source="item.values">-->
<!--                <a-list-item slot="renderItem" slot-scope="spec">-->
<!--                  <color-sku-item-->
<!--                    v-if="item.code===goods.basicSpec"-->
<!--                    @onColorImgUpload="onColorImgUpload"-->
<!--                    :item="spec"-->
<!--                    @onRemove="onSpecRemove"/>-->
<!--                  <size-sku-item-->
<!--                    v-if="item.code !== goods.basicSpec"-->
<!--                    :item="spec"-->
<!--                    @onRemove="onSpecRemove"/>-->
<!--                </a-list-item>-->
<!--              </a-list>-->
<!--            </a-card>-->
<!--          </a-col>-->
          <a-col :span="8">
            <a-card
              :title="$t(item.name)"
              style="margin-top: 20px"
              :key="`${item.value}${index}`"
              v-for="(item,index) in attribute.data">
              <a-button
                v-if="item.code !== goods.basicSpec"
                slot="extra"
                type="link"
                @click="setBasicSpec(item.code)">
                <a-icon type="file-image"/>
              </a-button>
              <a-button slot="extra" type="link" @click="addSpec(item.code)">
                {{ $t('ADD') }}
              </a-button>
              <a-button
                slot="extra"
                type="link"
                @click="removeAttribute(item.id)">{{ $t('REMOVE') || '删除' }}
              </a-button>
              <a-list :data-source="item.values">
                <a-list-item slot="renderItem" slot-scope="spec">
                  <color-sku-item
                    v-if="item.code===goods.basicSpec"
                    @onColorImgUpload="onColorImgUpload"
                    :item="spec"
                    @onRemove="onSpecRemove"/>
                  <size-sku-item
                    v-if="item.code !== goods.basicSpec"
                    :item="spec"
                    @onRemove="onSpecRemove"/>
                </a-list-item>
              </a-list>
            </a-card>
            <a-button
              type="dashed"
              block
              :disabled="attribute.data.length===2"
              style="margin-top: 20px"
              @click="addAttribute">{{ $t('ADD') }}

            </a-button>
          </a-col>
          <a-col :span="16">
            <a-card title="SKU 列表" style="margin-top: 20px">
              <a-button slot="extra" type="link" @click="generateSKUs">刷新</a-button>
              <a-table
                :pagination="false"
                :scroll="{ y: 'calc(100vh - 380px)' }"
                row-key="id"
                :data-source="table.data">
                <a-table-column
                  data-index="coverPath"
                  title="图片">
                  <template slot-scope="text,record">
                    <a-avatar
                      slot="avatar"
                      :src="record.image"
                    />
                  </template>
                </a-table-column>
                <a-table-column
                  data-index="code"
                  title="编码"
                >
                </a-table-column>
                <a-table-column
                  data-index="specs"
                  title="属性">
                </a-table-column>
                <a-table-column title="价格" data-index="price"/>
                <a-table-column title="数量" data-index="quantity"/>
                <a-table-column
                  data-index="date"
                  :title="$t('OPERATION') || '操作'">
                  <template slot-scope="text, record">
                    <a-button type="link" @click="editGoodsSku(record.id)">{{ $t('EDIT') || '编辑' }}
                    </a-button>
                    <a-button type="link" @click="deleteGoodsSku(record.id)">{{ $t('DELETE') || '删除' }}
                    </a-button>
                  </template>
                </a-table-column>
              </a-table>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <a-modal
      :footer="null"
      :close-on-click-modal="false"
      :width="800"
      title="SKU 编辑"
      v-model="form.visible">
      <goodsSku-edit
        v-if="form.visible"
        :goods-sku-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goodsSku-edit>
    </a-modal>
    <a-modal
      :footer="null"
      :close-on-click-modal="false"
      :width="800"
      title="添加属性"
      v-model="attributeForm.visible">
      <dict-select
        style="width: 100%"
        dict-code="GOODS_ATTRIBUTE"
        v-model="attributeForm.data.code"/>
      <div style="margin-top: 20px">
        <a-button block type="danger" @click="saveAttribute">保存
        </a-button>
      </div>
    </a-modal>
    <a-modal
      :footer="null"
      :close-on-click-modal="false"
      fullscreen
      title="添加属性值"
      v-model="attributeValueForm.visible">
      <a-input v-model="attributeValueForm.data.value"/>
      <div style="margin-top: 20px">
        <a-button block type="danger" @click="saveSpec">保存
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { _queryGoodsAttributes, _deleteGoodsAttribute, _addGoodsAttribute } from '@/api/goodsAttributeApi';
import { _queryGoodsAttributeValues } from '@/api/goodsAttributeValueApi';
import { _queryGoodsById, _setGoodsBasicSpec } from '@/api/goodsApi';
import { _deleteGoodsSku, _generateGoodsSkus, _queryGoodsSkus } from '@/api/goodsSkuApi';
import ColorSkuItem from '@/components/skuEdit/ColorSkuItem.vue';
import SizeSkuItem from '@/components/skuEdit/SizeSkuItem.vue';
import GoodsSkuEdit from './GoodsSkuEdit.vue';
import DictSelect from '@/components/DictSelect.vue';

async function getGoodsSkuList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  this.table.data = await _queryGoodsSkus(this.goodsId, {
    page: this.table.query.page,
    size: 999,
    sort: 'sortWeight',
    direction,
  });
}

function addSpec(code) {
  this.attributeValueForm.data.value = '';
  this.attributeValueForm.data.code = code;
  this.attributeValueForm.visible = true;
}

async function setBasicSpec(code) {
  this.goods.basicSpec = code;
  await _setGoodsBasicSpec(this.goodsId, { code });
}

function editGoodsSku(goodsSkuId) {
  this.form.data.id = goodsSkuId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsSkuList();
}

function saveSpec() {
  if (!this.attributeValueForm.data.value) {
    return;
  }
  const data = this.attribute.data.map((x) => {
    if (x.code === this.attributeValueForm.data.code) {
      if (!x.values.map(v => v.value).includes(this.attributeValueForm.data.value)) {
        return {
          ...x,
          values: [
            ...x.values,
            {
              value: this.attributeValueForm.data.value,
              imgPath: null,
              attributeCode: this.attributeValueForm.data.code,
            },
          ],
        };
      }
      return {
        ...x,
      };
    }
    return x;
  });
  this.attribute.data = [];
  this.attribute.data = data;
  this.attributeValueForm.visible = false;
  this.generateSKUs();
}

async function generateSKUs() {
  this.table.data = await _generateGoodsSkus(this.goodsId, this.attribute.data.map(x => ({
    attributeId: x.id,
    code: x.code,
    values: x.values,
  })));
}

// async function refreshWDT() {
//   if (this.goodsCode) {
//     const loadingEl = Loading.service({
//       fullscreen: true,
//       text: '正在同步WDT,请耐心等待',
//     });
//     await _refreshGoodsWDTId({ goodsCode: this.goodsCode });
//     this.$message({
//       type: 'success',
//       message: '更新!',
//     });
//     loadingEl.close();
//   }
// }

async function deleteGoodsSku(goodsSkuId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoodsSku(goodsSkuId);
      this.$message.success('删除成功');
      this.getGoodsSkuList();
    },
  });
}

function addAttribute() {
  this.attributeForm.data.value = '';
  this.attributeForm.data.code = '';
  this.attributeForm.visible = true;
}

async function removeAttribute(id) {
  this.$confirm({
    title: '是否删除该属性？',
    content: '',
    onOk: async () => {
      this.attribute.data = this.attribute.data.filter(x => x.id !== id);
      await _deleteGoodsAttribute(this.goodsId, id);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.initAttribute();
      await this.generateSKUs();
    },
  });
}

async function saveAttribute() {
  if (this.attribute.data.filter(x => x.code === this.attributeForm.data.code).length > 0) {
    this.attributeForm.data.code = '';
    this.attributeForm.data.name = '';
    this.attributeForm.visible = false;
    return;
  }
  const { name } = this.$store.getters.getDictionaryDataByKey(`GOODS_ATTRIBUTE-${this.attributeForm.data.code}`);
  await _addGoodsAttribute(this.goodsId, {
    code: this.attributeForm.data.code,
    name,
  });
  this.$message.success(this.$t('REMOVE_SUCCESS'));
  this.initAttribute();
  this.attributeForm.data.code = '';
  this.attributeForm.data.name = '';
  this.attributeForm.visible = false;
}

async function initAttribute() {
  const { content } = await _queryGoodsAttributes(this.goodsId, {});
  const { content: valueContent } = await _queryGoodsAttributeValues(this.goodsId, {});
  this.attribute.data = content.filter(x => x.isActive === 'YES')
    .map(x => ({
      ...x,
      values: valueContent.filter(v => v.isActive === 'YES' && v.attributeCode === x.code),
    }));
}

export default {
  name: 'GoodsSkuList',
  components: {
    SizeSkuItem,
    ColorSkuItem,
    GoodsSkuEdit,
    DictSelect,
  },
  props: {
    goodsId: String,
    goodsCode: String,
  },
  data() {
    return {
      attribute: {
        data: [],
      },
      goods: {
        id: '',
        price: 0,
        name: '',
        categoryId: '',
        basicSpec: '',
      },
      attributeValueForm: {
        visible: false,
        data: {
          value: '',
          code: '',
        },
      },
      attributeForm: {
        visible: false,
        data: {
          value: '',
          code: null,
        },
      },
      form: {
        loading: false,
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getGoodsSkuList,
    deleteGoodsSku,
    editGoodsSku,
    addSpec,
    setBasicSpec,
    closeForm,
    generateSKUs,
    saveSpec,
    removeAttribute,
    addAttribute,
    initAttribute,
    saveAttribute,
    onColorImgUpload(item) {
      this.attribute.data = this.attribute.data.filter(x => x.value !== item.value);
      this.attribute.data = this.attribute.data.map((x) => {
        if (x.code === item.attributeCode) {
          return {
            ...x,
            values: x.values.map(v => ({
              ...v,
              imgPath: item.value === v.value ? item.imgPath : v.imgPath,
            })),
          };
        }
        return x;
      });
      this.generateSKUs();
    },
    onSpecRemove(item) {
      this.attribute.data = this.attribute.data.map((x) => {
        if (x.code === item.attributeCode) {
          return {
            ...x,
            values: x.values.filter(v => v.value !== item.value),
          };
        }
        return x;
      });
      this.generateSKUs();
    },
  },
  async created() {
    this.form.loading = true;
    const goodsResult = await _queryGoodsById(this.goodsId);
    this.goods.name = goodsResult.name;
    this.goods.categoryId = goodsResult.categoryId;
    this.goods.basicSpec = goodsResult.basicSpec;
    await this.initAttribute();
    // const { content } = await _queryGoodsAttributes({});
    // const { content: valueContent } = await _queryGoodsAttributeValues(this.goodsId, {});
    // this.attribute.data = content.filter(x => x.isActive === 'YES').map(x => ({
    //   ...x,
    //   values: valueContent.filter(v => v.isActive === 'YES' && v.attributeCode === x.code),
    // }));
    await this.getGoodsSkuList();
    this.form.loading = false;
  },
};
</script>

<style scoped>
.sku-wrap {
  border: 1px solid #eeeeee;
  border-left: 5px solid #000000;
  margin: 10px 0;
  padding: 10px;
}
</style>
